import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ArquivoExtratoService} from '../../services/arquivo-extrato/arquivo-extrato.service';
import {ArquivoExtrato} from '../../core/arquivo-extrato';
import {FiltroArquivoExtrato} from '../../core/filtro-arquivo-extrato';
import {Page} from '../../core/page';
import {ToastService} from 'src/app/services/toast/toast.service';
import {LoadingPopupService} from 'src/app/services/loadingPopup/loading-popup.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ImportarArquivoDialogComponent} from './importar-arquivo-dialog/importar-arquivo-dialog.component';
import {ErroImportacaoDialogComponent} from './erro-importacao-dialog/erro-importacao-dialog.component';
import {ConfirmDialogComponent} from '../common/confirm-dialog/confirm-dialog.component';
import {DataUtilService} from 'src/app/services/commons/data-util.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Acesso} from 'src/app/core/acesso';
import {CarregarPerfil} from 'src/app/core/carregar-perfil';
import {AcessoService} from '../../services/acesso/acesso.service';
import {switchMap} from 'rxjs/operators';
import * as _ from 'lodash';
import {of} from 'rxjs';

@Component({
    selector: 'arquivo-extrato',
    templateUrl: './arquivo-extrato.component.html',
    styleUrls: ['./arquivo-extrato.component.css']
})
export class ArquivoExtratoComponent implements OnInit, AfterViewInit {

    // File upload properties
    arquivoSelecionado: File | null = null;
    carregando = false;

    // Permission properties
    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();
    podeAssociar = false;

    // Filter properties
    filtroNomeArquivo: string = '';
    filtroNumeroBanco: string = '';
    filtroNumeroConta: string = '';
    filtroDataInicio: string = '';
    filtroDataFim: string = '';

    // Table properties
    displayedColumns: string[] = [
        'nomeArquivo',
        'bancoConta',
        'dataImportacao',
        'statusGeral',
        'acoes'
    ];

    dataSource: MatTableDataSource<ArquivoExtrato>;
    mostrarTabela = false;
    msg = 'Carregando arquivos...';

    // Pagination properties
    totalElements = 0;
    pageSize = 5;
    pageSizeOptions = [5, 10, 20, 50];
    currentPage = 0;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private arquivoExtratoService: ArquivoExtratoService,
        private toastService: ToastService,
        private loadingPopupService: LoadingPopupService,
        private dialog: MatDialog,
        private dataUtilService: DataUtilService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private acessoService: AcessoService
    ) {
        this.dataSource = new MatTableDataSource();
    }

    ngOnInit(): void {
        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

        this.carregarPerfilSecundario();

        this.carregarArquivos();
    }

    ngAfterViewInit(): void {
        // Configurar paginador após a view ser inicializada
        if (this.paginator) {
            this.sincronizarPaginador();
        }
    }

    // File upload methods
    abrirDialogoImportacao(): void {
        if (!this.perfilAcesso.insere) {
            this.toastService.showAlerta('Você não tem permissão para importar arquivos.');
            return;
        }

        const dialogRef = this.dialog.open(ImportarArquivoDialogComponent, {
            width: '500px',
            disableClose: false,
            data: {
                disableClose: false,
                perfilAcesso: [this.perfilAcesso]
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.arquivo) {
                this.arquivoSelecionado = result.arquivo;
                this.importarArquivo();
            }
        });
    }

    importarArquivo(): void {
        if (!this.arquivoSelecionado) {
            this.toastService.showAlerta('Selecione um arquivo para importar');
            return;
        }

        if (!this.perfilAcesso.insere) {
            this.toastService.showAlerta('Você não tem permissão para importar arquivos.');
            return;
        }

        this.carregando = true;
        this.loadingPopupService.mostrarMensagemDialog('Processando arquivo...');

        this.arquivoExtratoService.importarArquivo(this.arquivoSelecionado).subscribe({
            next: (response: ArquivoExtrato) => {
                this.loadingPopupService.closeDialog();
                this.carregando = false;
                this.toastService.showSucesso('Arquivo processado com sucesso!');
                this.limparSelecao();

                if (response && response.id) {
                    if (response.importadoSucesso)
                        this.router.navigate(['/arquivo-extrato/associar', response.id]);
                    else {
                        this.carregarArquivos();
                        this.abrirPopupErroImportacao(response);
                    }
                } else {
                    this.carregarArquivos();
                }
            },
            error: (error) => {
                this.loadingPopupService.closeDialog();
                this.carregando = false;
                console.error('Erro ao processar arquivo:', error);
                this.toastService.showAlerta('Erro ao processar arquivo. Tente novamente.');
            }
        });
    }

    limparSelecao(): void {
        this.arquivoSelecionado = null;
    }

    // Table methods
    carregarArquivos(): void {
        // Validar datas antes de carregar
        if (!this.validarDatas()) {
            return;
        }

        this.loadingPopupService.mostrarMensagemDialog('Carregando arquivos...');

        // Preparar filtros para envio ao serviço
        const filtro: FiltroArquivoExtrato = {
            nomeArquivo: this.filtroNomeArquivo || undefined,
            numeroBanco: this.filtroNumeroBanco ? Number(this.filtroNumeroBanco) : undefined,
            numeroConta: this.filtroNumeroConta || undefined,
            dataInicio: this.filtroDataInicio || undefined,
            dataFim: this.filtroDataFim || undefined
        };

        this.arquivoExtratoService.pesquisarPaginado(filtro, this.currentPage, this.pageSize).subscribe({
            next: (page: Page<ArquivoExtrato>) => {
                this.dataSource.data = page.content;
                this.totalElements = page.totalElements;
                // Não configurar paginator no dataSource para paginação do servidor
                this.dataSource.sort = this.sort;
                this.mostrarTabela = page.content.length > 0;
                this.msg = page.content.length === 0 ? 'Nenhum arquivo encontrado' : '';

                // Sincronizar paginador após carregar dados
                this.sincronizarPaginador();

                this.loadingPopupService.closeDialog();
            },
            error: (error) => {
                console.error('Erro ao carregar arquivos:', error);
                this.loadingPopupService.closeDialog();
                this.toastService.showAlerta('Erro ao carregar arquivos. Tente novamente.');
                this.msg = 'Erro ao carregar arquivos';
            }
        });
    }

    obterStatusAssociacaoTexto(statusAssociacao: string): string {
        switch (statusAssociacao) {
            case 'TOTALMENTE_ASSOCIADO':
                return 'Totalmente Associado';
            case 'PARCIALMENTE_ASSOCIADO':
                return 'Parcialmente Associado';
            case 'NAO_ASSOCIADO':
                return 'Aguardando';
            case 'SEM_LINHAS':
                return 'Sem Linhas';
            case 'ERRO_IMPORTACAO':
                return 'Erro na Importação';
            default:
                return 'Não Informado';
        }
    }

    obterCorStatusAssociacao(statusAssociacao: string): string {
        switch (statusAssociacao) {
            case 'TOTALMENTE_ASSOCIADO':
                return '#4caf50'; // Verde
            case 'PARCIALMENTE_ASSOCIADO':
                return '#ff9800'; // Laranja
            case 'NAO_ASSOCIADO':
                return '#4ea125'; // Vermelho
            case 'SEM_LINHAS':
                return '#666'; // Cinza
            case 'ERRO_IMPORTACAO':
                return '#f44336'; // Vermelho
            default:
                return '#666';
        }
    }

    abrirPopupErroImportacao(arquivo: ArquivoExtrato): void {
        this.dialog.open(ErroImportacaoDialogComponent, {
            width: '500px',
            data: {
                observacoes: arquivo.observacoes || 'Erro não especificado.',
                nomeArquivo: arquivo.nomeArquivo
            }
        });
    }

    formatarDataHora(data: Date): string {
        if (!data) return '-';
        return new Date(data).toLocaleString('pt-BR');
    }

    consultar(): void {
        // Validar datas antes de consultar
        if (!this.validarDatas()) {
            return;
        }

        this.currentPage = 0; // Reset to first page when searching
        this.carregarArquivos();
    }

    limpar(): void {
        this.filtroNomeArquivo = '';
        this.filtroNumeroBanco = '';
        this.filtroNumeroConta = '';
        this.filtroDataInicio = '';
        this.filtroDataFim = '';
        this.currentPage = 0; // Reset to first page when clearing
        this.carregarArquivos();
    }

    onPageChange(event: PageEvent): void {
        this.currentPage = event.pageIndex;
        this.pageSize = event.pageSize;
        this.carregarArquivos();
    }

    onMascaraDataInput(event: any): void {
        this.dataUtilService.onMascaraDataInput(event);
    }

    /**
     * Valida a data inicial quando o usuário digita
     */
    onDataInicioChange(): void {
        if (this.filtroDataInicio && this.filtroDataFim) {
            this.validarDatas();
        }
    }

    /**
     * Valida a data final quando o usuário digita
     */
    onDataFimChange(): void {
        if (this.filtroDataInicio && this.filtroDataFim) {
            this.validarDatas();
        }
    }

    /**
     * Valida se a data inicial é menor que a data final
     * @returns true se as datas são válidas, false caso contrário
     */
    validarDatas(): boolean {
        // Se ambas as datas estão preenchidas, validar
        if (this.filtroDataInicio && this.filtroDataFim) {
            const dataInicio = new Date(this.filtroDataInicio);
            const dataFim = new Date(this.filtroDataFim);

            // Verificar se as datas são válidas
            if (isNaN(dataInicio.getTime()) || isNaN(dataFim.getTime())) {
                this.toastService.showAlerta('Por favor, insira datas válidas no formato DD/MM/AAAA');
                return false;
            }

            // Verificar se a data inicial é menor ou igual à data final
            if (dataInicio > dataFim) {
                this.toastService.showAlerta('A data inicial deve ser menor ou igual à data final');
                return false;
            }
        }

        return true;
    }

    atualizarLista(): void {
        this.carregarArquivos();
    }

    /**
     * Carrega o perfil de acesso secundário e define a permissão de associação
     */
    private carregarPerfilSecundario(): void {
        this.acessoService.getPerfilAcesso(this.activatedRoute.snapshot.data.moduloSecundario).pipe(
            switchMap((perfilAcesso: Acesso[]) => {
                if (_.isEmpty(perfilAcesso) || !perfilAcesso[0].consulta)
                    return of(null);
                return of(perfilAcesso);
            })
        ).subscribe((perfilSecundario: Acesso[]) => {
            if (perfilSecundario && perfilSecundario.length > 0)
                this.podeAssociar = true;
        });
    }

    /**
     * Sincroniza o paginador com os dados atuais
     */
    private sincronizarPaginador(): void {
        if (this.paginator) {
            this.paginator.length = this.totalElements;
            this.paginator.pageIndex = this.currentPage;
            this.paginator.pageSize = this.pageSize;
        }
    }

    /**
     * Navega para a tela de associação do arquivo selecionado
     */
    abrirAssociacao(arquivo: ArquivoExtrato): void {
        this.router.navigate(['/arquivo-extrato/associar', arquivo.id]);
    }

    excluirArquivo(arquivo: ArquivoExtrato): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: `Certeza que deseja excluir o arquivo "${arquivo.nomeArquivo}"?`,
            textoConfirma: 'SIM',
            textoCancela: 'NÃO'
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(confirma => {
            if (confirma) {
                this.arquivoExtratoService.excluir(arquivo.id).subscribe({
                    next: () => {
                        this.toastService.showSucesso('Arquivo excluído com sucesso.');
                        this.carregarArquivos();
                    },
                    error: () => {
                        this.toastService.showAlerta('Erro ao excluir o arquivo.');
                    }
                });
            }
        });
    }

}
